// extracted by mini-css-extract-plugin
export default {"fabrics":"EXec4","sizeS":"VGGiX","fabric":"rTpHt","selected":"vMCP3","image":"o7tP4","sizeM":"QWZjx","sizeL":"XMRW3"};